import formatISO from '@teetsh/app/src/utils/time/formatISO';
import {
  Item,
  Periode,
  PeriodeApi,
  Programmation,
  ProgrammationApi,
} from '@teetsh/app/src/types/programmations';
import parseISO from '@teetsh/app/src/utils/time/parseISO';

export function serializePeriode(periode: Periode) {
  return {
    ...periode,
    startDate: periode.startDate ? formatISO(periode.startDate) : undefined,
    endDate: periode.endDate ? formatISO(periode.endDate) : undefined,
  };
}

export function deserializePeriode(periode: PeriodeApi): Periode {
  return {
    ...periode,
    startDate: periode.startDate ? parseISO(periode.startDate) : undefined,
    endDate: periode.endDate ? parseISO(periode.endDate) : undefined,
  };
}

export function serializeProgrammation(programmation: Programmation) {
  return {
    ...programmation,
    periodes: programmation.periodes
      ? programmation.periodes.map(p => serializePeriode(p))
      : [],
  };
}

export function deserializeProgrammation(
  programmation: ProgrammationApi,
): Programmation {
  return {
    ...programmation,
    matieres: (programmation.matieres || []).map((m, i) => ({
      ...m,
      position: i,
      domaines: (m.domaines || []).map((d, ii) => ({
        ...d,
        position: ii + 1,
      })),
    })),
    periodes: (programmation.periodes || []).map((p, i) =>
      deserializePeriode({ ...p, position: p.position || i + 1 }),
    ),
  };
}

export function serializeProgrammationItem(rawItem: Item) {
  const { domaine, ...item } = rawItem;

  // Warning : do not serialize the domaine, there could be a circular serialization (item->domaine->periodeItems->item->...)
  // This happens when using matiere_x_periode view. See TSH-773
  return {
    ...item,
    sequenceId: item?.sequence?.id,
    ficheDePrepId: item?.ficheDePrep?.id,
  };
}
